import { render, staticRenderFns } from "./ShoppingListV2.vue?vue&type=template&id=4dfb0bfb&scoped=true"
import script from "./ShoppingListV2.vue?vue&type=script&lang=js"
export * from "./ShoppingListV2.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListV2.vue?vue&type=style&index=0&id=4dfb0bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb0bfb",
  null
  
)

export default component.exports